import { PROJECTS } from "../data/portfolio";

const ProjectsSection = () => (
  <section className="section-enter max-w-[1180px]">
    <div className="mb-2 flex items-baseline gap-4">
      <h2 className="font-heading text-[40px] font-medium tracking-[-0.02em]">
        Projects
      </h2>
      <span className="text-[10.5px] uppercase tracking-kicker text-accent-300">
        Built, not just described
      </span>
    </div>

    <p className="mb-7 max-w-[660px] text-[14.5px] text-neutral-500">
      Personal work shipped end to end — live in production, not a portfolio mockup.
    </p>

    <div className="grid grid-cols-2 gap-3.5">
      {PROJECTS.map((p) => (
        <a
          key={p.name}
          href={p.url}
          target="_blank"
          rel="noopener noreferrer"
          className="card flex flex-col gap-3 p-[22px]"
        >
          <div className="flex items-center justify-between gap-2.5">
            <h3 className="font-heading text-[19px] font-medium tracking-[-0.01em]">
              {p.name}
            </h3>
            <span className="text-[10px] uppercase tracking-[0.2em] text-accent-300">
              {p.status}
            </span>
          </div>

          <p className="text-[13px] leading-[1.55] text-neutral-400">{p.description}</p>

          <ul className="mt-auto flex flex-wrap gap-1.5">
            {p.stack.map((s) => (
              <li
                key={s}
                className="rounded-full border border-neutral-800 px-2 py-0.5 text-[10.5px] text-neutral-400"
              >
                {s}
              </li>
            ))}
          </ul>

          <span className="text-[11px] text-accent-300 underline underline-offset-2">
            {p.url.replace(/^https?:\/\//, "").replace(/\/$/, "")}
          </span>
        </a>
      ))}
    </div>
  </section>
);

export default ProjectsSection;
